<template>
  <v-hover v-if="showIcon" v-model="val" :open-delay="0" :close-delay="0">
    <template v-slot="{ isHovering, props: hoverProps }">
      <span :data-cy="dataCy" v-bind="hoverProps">
        <v-btn class="popover-status-icon" variant="text" @click="val = !val">
          <v-icon v-if="icon" :color="iconColor">
            {{ icon }}
          </v-icon>
          <img v-else :src="imgSrc" :alt="imgAlt" />
        </v-btn>
        <v-tooltip
          :content-class="tooltipContentClass"
          :model-value="isHovering ?? false"
          location="bottom"
        >
          <template v-slot:activator="{ props: tooltipProps }">
            <span v-bind="tooltipProps"></span>
          </template>
          <span>
            {{ iconText }}
          </span>
        </v-tooltip>
      </span>
    </template>
  </v-hover>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BaseIcon',
  props: {
    showIcon: Boolean,
    icon: String,
    iconColor: {
      type: String,
      default: 'grey'
    },
    imgSrc: String,
    imgAlt: String,
    iconText: String,
    tooltipContentClass: String,
    dataCy: String
  },
  data() {
    return {
      val: false
    }
  }
})
</script>
